export const radius = { xs: 6, sm: 10, md: 14, lg: 18, xl: 24, pill: 999 } as const;
export const space  = { 1:4, 2:8, 3:12, 4:16, 5:20, 6:24, 8:32, 10:40, 12:48, 16:64 } as const;

/** 카드 기본은 elevation/0 + 테두리. 그림자는 진짜로 떠 있는 것에만. */
export const elevation = {
  0: "none",
  1: "0 1px 2px rgba(26,20,32,.06)",
  2: "0 4px 12px rgba(26,20,32,.08)",
  3: "0 8px 24px rgba(26,20,32,.12)",
  4: "0 -4px 24px rgba(26,20,32,.14)",
} as const;

export const touchTarget = { ios: 44, android: 48, min: 32 } as const;

/** 18_RESPONSIVE_STRATEGY §2 */
export const breakpoints = { xs: 320, sm: 390, md: 768, lg: 1024, xl: 1440 } as const;
